"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForceUpdateArrearsOrderBodySchema = exports.UpdateArrearsOrderBodySchema = exports.PayArrearsOrderBodySchema = exports.HistoricalTeamSpendSchema = exports.HistoricalCampaignSpendSchema = exports.HistoricalAppleCampaignSpendSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const accounts_web_1 = require("../../accounts-web");
exports.HistoricalAppleCampaignSpendSchema = (0, core_1.StrictObject)({
    from: core_1.TimestampSchema,
    to: core_1.TimestampSchema,
    campaignRef: ruby_1.AppleProxyRefSchema,
    spend: core_1.MoneySchema,
});
exports.HistoricalCampaignSpendSchema = (0, core_1.StrictObject)({
    campaign: (0, core_1.StrictObject)({
        id: core_1.IdSchema,
        name: core_1.NameSchema,
        channelType: ruby_1.ChannelTypeSchema,
    }),
    appleCampaigns: typebox_1.Type.Array(exports.HistoricalAppleCampaignSpendSchema),
});
exports.HistoricalTeamSpendSchema = (0, core_1.StrictObject)({
    team: ruby_1.TeamContextSchema,
    campaigns: typebox_1.Type.Array(exports.HistoricalCampaignSpendSchema),
});
exports.PayArrearsOrderBodySchema = (0, core_1.StrictObject)({
    tier: accounts_web_1.TierSchema,
    teamId: core_1.IdSchema,
    order: (0, core_1.StrictObject)({
        // Invoice period
        start: core_1.TimestampSchema,
        end: core_1.TimestampSchema,
    }),
});
exports.UpdateArrearsOrderBodySchema = (0, core_1.StrictObject)({
    spend: exports.HistoricalTeamSpendSchema,
    tier: accounts_web_1.TierSchema,
    order: (0, core_1.StrictObject)({
        // Invoice period
        start: core_1.TimestampSchema,
        end: core_1.TimestampSchema,
        spend: core_1.MoneySchema,
    }),
});
exports.ForceUpdateArrearsOrderBodySchema = (0, core_1.StrictObject)({
    tier: accounts_web_1.TierSchema,
    order: (0, core_1.StrictObject)({
        start: core_1.TimestampSchema,
        end: core_1.TimestampSchema,
    }),
});
